import { initializeApp } from "firebase/app";
import { useEffect, useState } from "react";
import "./styles.css";

const firebaseConfig = {
  apiKey: "AIzaSyBg3u1sJlyJwQCE95oSDH_mtLABS-is8ZM",
  authDomain: "rxfire-525a3.firebaseapp.com",
  databaseURL: "https://rxfire-525a3.firebaseio.com",
  projectId: "rxfire-525a3",
  storageBucket: "rxfire-525a3.appspot.com",
  messagingSenderId: "844180061847",
  appId: "1:844180061847:web:400f7142e2d1aaeb"
};

export default function App() {
  const [initTime, setInitTime] = useState<number | null>(null);

  useEffect(() => {
    const lazyLoadFirebase = async () => {
      const app = initializeApp(firebaseConfig);
      const startTime = new Date().getTime();
      console.time();
      const { getFirestore } = await import(
        /* webpackChunkName: "TEST" */ "firebase/firestore"
      );
      console.timeEnd();
      getFirestore(app);
      setInitTime(new Date().getTime() - startTime);
    };

    lazyLoadFirebase();
  }, []);

  return (
    <div className="App">
      <h1>Hello CodeSandbox</h1>
      <h2>Init time: {initTime}</h2>
    </div>
  );
}
